import React from "react"
import {IonBadge} from "@ionic/react"
import User from "../../../types/User";

interface componentProps {
    item: User
}

const BadgeUserIsAdmin: React.FC<componentProps> = ({ item }: componentProps) => {

    return (
        <IonBadge color="bc-yellow" className="ion-hide-md-down" slot="end" style={
            {
                'color': 'white',
                'fontWeight': 500,
                'minWidth': '100px',
                '--padding-top': '6px', '--padding-bottom': '6px',
                '--padding-start': '8px', '--padding-end': '8px',
                'marginRight': '6px'
            }
        }>
            Admin
        </IonBadge>
    )
}

export default BadgeUserIsAdmin